<script>
    import {
        Button,
        Modal,
        ModalBody,
        ModalFooter,
        ModalHeader
    } from "sveltestrap";

    import Icon from 'svelte-awesome';
    import shoppingBasket from "svelte-awesome/icons/shopping-basket";
    import child from "svelte-awesome/icons/child";
    import calendar from "svelte-awesome/icons/calendar";
    import fileWord from "svelte-awesome/icons/file-word-o";

    import EventDateForm from './forms/EventDateForm.svelte';
    import EventMinimumAgeForm from './forms/EventMinimumAgeForm.svelte';
    import EventTextForm from './forms/EventTextForm.svelte';
    import {getContext} from "svelte";

    const MyAnalytics = getContext('MyAnalytics');

    const forms = {
        ticket: {
            title: 'Ticket link',
            icon: shoppingBasket,
            form: EventDateForm,
        },
        date: {
            title: 'Event date',
            icon: calendar,
            form: EventDateForm,
        },
        minimumAge: {
            title: 'Minimum age',
            icon: child,
            form: EventMinimumAgeForm,
        },
        text: {
            title: 'Text',
            icon: fileWord,
            form: EventTextForm,
        },
    };

    export let event;
    export let form;
    export let id = false;

    const editModeActive = getContext('editMode');

    let open = false;
    const toggle = () => (open = !open);

    const handleClick = () => {
        MyAnalytics.logEvent('event_edit_open', {
            form: form,
            event_id: event.id,
            sub_id: id,
        });
        toggle();
    }
    const completed = async () => {
        await MyAnalytics.logEvent('event_edit_completed', {
            form: form,
            event_id: event.id,
            sub_id: id,
        });
        await toggle(); // have to wait, animation blocks further processing
        getContext('reloadEvent')();
    };
</script>

{#if $editModeActive}
    <div class="editButton">
        <Button color="light" on:click={handleClick}>
            <Icon data={forms[form].icon}/>
        </Button>
    </div>

    <Modal isOpen={open} {toggle}>
        <ModalHeader {toggle}>{forms[form].title}</ModalHeader>
        <ModalBody>
            <svelte:component this={forms[form].form} {event} {id} completed={completed}/>
        </ModalBody>
    </Modal>
{/if}

<style>
    .editButton {
        position: absolute;
        right: 0px;
        z-index: 100;
    }
</style>